import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Um pipe que contorna a sanitização de segurança do Angular para HTML.
 * É usado para renderizar strings de SVG, que são consideradas seguras neste contexto,
 * dentro do template usando a propriedade `[innerHTML]`.
 */
@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitizer: DomSanitizer = inject(DomSanitizer);

  /**
   * Transforma uma string contendo HTML (neste caso, um SVG) em um objeto `SafeHtml`
   * que o Angular considera seguro para renderização.
   *
   * @param value A string HTML a ser sanitizada.
   * @returns O valor `SafeHtml` que pode ser usado com `[innerHTML]`.
   */
  public transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
